import { render } from "./manage-pages-banner.vue?vue&type=template&id=5998b73c"
import script from "./manage-pages-banner.vue?vue&type=script&lang=js"
export * from "./manage-pages-banner.vue?vue&type=script&lang=js"

import "./manage-pages-banner.vue?vue&type=style&index=0&id=5998b73c&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__